import React from 'react';

export const SearchGray300Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4666 10.5333L14.4666 13.5333C14.7333 13.8 14.7333 14.2 14.4666 14.4666C14.3333 14.6 14.1333 14.6666 13.9999 14.6666C13.8666 14.6666 13.6666 14.6 13.5333 14.4666L10.5333 11.4666C9.53325 12.2 8.33325 12.6666 6.99992 12.6666C3.86659 12.6666 1.33325 10.1333 1.33325 6.99998C1.33325 3.86665 3.86659 1.33331 6.99992 1.33331C10.1333 1.33331 12.6666 3.86665 12.6666 6.99998C12.6666 8.33331 12.1999 9.59998 11.4666 10.5333ZM6.99992 2.66665C4.59992 2.66665 2.66659 4.59998 2.66659 6.99998C2.66659 9.39998 4.59992 11.3333 6.99992 11.3333C8.19992 11.3333 9.26659 10.8666 10.0666 10.0666C10.8666 9.26665 11.3333 8.19998 11.3333 6.99998C11.3333 4.59998 9.39992 2.66665 6.99992 2.66665Z"
        fill="#DCDCDC"
      />
    </svg>
  );
};
